import { RootState } from 'store/rootReducer';

export const UnauthorizedErrorPageContentSelector = (state: RootState) => state.content.unauthorizedErrorPage;
